import React from 'react';

let q = [
  {
    question: (
      <>
        <b>IDealan</b>
        <br />
        godišnji odmor?
      </>
    ),
    correct: 1,
    answers: [2, 1, 0, 3],
  },
  {
    question: (
      <>
        Omiljena
        <br />
        <b>društvena mreža?</b>
      </>
    ),
    correct: 1,
    answers: [0, 1, 2, 3],
  },
  {
    question: (
      <>
        Što voliš raditi
        <br />
        <b>na izletima?</b>
      </>
    ),
    correct: 1,
    answers: [2, 0, 3, 1],
  },
  {
    question: (
      <>
        U kojem gradu
        <br />
        <b>bi volio živjeti?</b>
      </>
    ),
    correct: 0,
    answers: [0, 3, 1, 2],
  },
  {
    question: (
      <>
        <b>IDealno</b>
        <br />
        mjesto stanovanja?
      </>
    ),
    correct: 1,
    answers: [1, 3, 0, 2],
  },
];

q.forEach((q, qi) => {
  q.answers = q.answers.map((a, i) => ({ a, i, qi, cls: q.answerCls || '' }));
});

export default q;
